import { ElementType, type FC, useId } from "react";
import { Box } from "@mui/material";

import laptopBlank from "./assets/laptop-blank.png";

const GRADIENT_TOP = "#67C275";
const GRADIENT_BOTTOM = "#C1E0C6";

const SCREEN_SKEW_Y = "8deg";

interface InfoPageIllustrationProps {
  icon: ElementType;
  alt?: string;
}

export const InfoPageIllustration: FC<InfoPageIllustrationProps> = ({
  icon: Icon,
  alt = "",
}) => {
  const gradientId = `info-page-gradient-${useId().replace(/:/g, "")}`;

  return (
    <Box
      role={alt ? "img" : undefined}
      aria-label={alt || undefined}
      aria-hidden={alt ? undefined : true}
      sx={{ maxWidth: "100%", position: "relative", width: 384 }}
    >
      <Box
        component="img"
        src={laptopBlank}
        alt=""
        sx={{ display: "block", height: "auto", width: "100%" }}
      />
      <svg width={0} height={0} style={{ position: "absolute" }} aria-hidden={true}>
        <defs>
          <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor={GRADIENT_TOP} />
            <stop offset="1" stopColor={GRADIENT_BOTTOM} />
          </linearGradient>
        </defs>
      </svg>
      <Icon
        sx={{
          fill: `url(#${gradientId})`,
          height: "26%",
          left: "57.8%",
          position: "absolute",
          top: "42.1%",
          transform: `translate(-50%, -50%) skewY(${SCREEN_SKEW_Y})`,
          width: "26%",
        }}
      />
    </Box>
  );
};
